var r = /* @__PURE__ */ ((H) => (H[H.Default = 0] = "Default", H[H.H2 = 2] = "H2", H[H.H3 = 3] = "H3", H[H.H4 = 4] = "H4", H))(r || {});
export {
  r as TextLevelEnum
};
